import React from "react";

const CustomerWallet = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-white to-blue-200 px-4">
      <div className="bg-white/80 backdrop-blur-xl shadow-2xl border border-blue-100 rounded-3xl p-10 max-w-md w-full text-center">
        <h1 className="text-4xl font-extrabold text-blue-700 mb-4">💳 BYN Wallet</h1>
        <p className="text-gray-700 text-lg leading-relaxed">
          The BYN Wallet feature is currently under maintenance while we upgrade 
          to our new real-time payment system.
        </p>
        <p className="mt-4 text-gray-600">
          For now, all ride and job payments are securely handled automatically after
          completion — no wallet setup needed.
        </p>
        <button
          onClick={() => window.history.back()}
          className="mt-8 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl shadow-md font-semibold transition"
        >
          ← Go Back
        </button>
      </div>
    </div>
  );
};

export default CustomerWallet;
